




























































import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import {AddressTitle, Salutation} from "@/helpers/constants";
import AddressUpdate from "@/models/address/AddressUpdate";
import {enumToSelectItems} from "@/helpers/functions_asi";
import Address from "@/models/address/Address";
import {AxiosError} from "axios";
import AsiTextField from "@/components/common/AsiTextField";
import AsiCountryAutocompleteInput from "@/components/common/AsiCountryAutocompleteInput.vue";
import AsiCheckbox from "@/components/common/AsiCheckbox";
import CompanySimple from "@/models/company/CompanySimple";
import AsiAutocomplete from "@/components/common/AsiAutocomplete";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";

@Component({
	components: {
		AsiDialogFormLayout,
		AsiAutocomplete,
		AsiCheckbox, AsiCountryAutocompleteInput, AsiTextField
	}
})
export default class CompanyUpdateDialogContactAddress extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public address!: Address;

	@Prop({type: Object, required: true})
	public company!: CompanySimple | null;

	private model: AddressUpdate | null = null;
	private salutationOptions = enumToSelectItems(Salutation, true);
	private titleOptions = enumToSelectItems(AddressTitle, true);

	public created(): void {
		this.setAddressInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setAddressInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('address', {deep: true})
	private onAddressChanged(): void {
		this.setAddressInternal();
	}

	private setAddressInternal(): void {
		if (this.model === null) {
			this.model = new AddressUpdate(this.address);
		} else {

			this.model.setDetailModel(this.address);
		}
	}

	private requestSave(event: Event): void {
		if (this.company === null || this.model === null) return;

		this.loading = true;
		this.$companyService.updateContactAddress(this.company.id, this.model)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
